<template>
<div :class="{card: true, block: true, 'product-selected': selected}">
  <div class="columns is-gapless is-vcentered">
      <div class="column is-narrow">
          <div class="card-image">
              <figure class="image is-96x96">
                  <img :src="getImage(product)"
                      :alt="product.node.title">
              </figure>
          </div>
      </div>
      <div class="column">
          <div class="p-4">
              <div class="content mb-2">
                  {{product.node.title}}
              </div>
              <div class="buttons">
                  <div class="columns is-vcentered">
                      <div class="column">
                          <button :class="{button: true, 'is-warning': selected}" @click='selectProduct(product)'>{{ selected ? 'Selected' : 'Select' }}</button>                                            
                      </div>
                      <div class="column">
                          <label :for="product.node.id" v-if="selected" class="label has-text-right">Quantity</label>
                      </div>
                      <div class="column">
                          <input :id="product.node.id" class="input" v-if="selected" v-model="qty" type="number" min="1" max="3" @change="qtyChanged($event)"/>
                      </div>
                  </div>                                            
              </div>
          </div>
      </div>
  </div>
</div>

</template>

<script>
import _get from 'lodash/get'

export default {
  name: "product-item",

  data: () => ({
    selected: false,
    qty: 1,
  }),
  computed: {
  }, 

  props: ["product"],
  mounted() {
  },
  methods: {
    getImage(product) {
      return _get(product, 'node.variants.edges[0].node.image.originalSrc');
    },
    selectProduct(product){
      this.selected = !this.selected;
      this.product.qty = parseInt(this.qty, 10)
      this.$emit('selected', product, this.selected)
    },
    qtyChanged(){
      // It will affect by reference the product that is already pushed into the parent's selectedProducts
      this.product.qty = parseInt(this.qty, 10)
    }
  },
};
</script>